import { LitElement } from 'lit-all'

export class HandleOverlay extends LitElement {
  static properties = {
    _overlayAdded: {
      type: Boolean,
    },
  }

  constructor() {
    super()

    this._overlayAdded = false
    this.closeOverlay.bind(this)
  }

  createOverlay(clickHandler) {
    const overlay = document.createElement('div')
    overlay.classList.add('nova-overlay')
    overlay.classList.add('hidden--md')
    overlay.classList.add('hidden--sm')

    document.body.appendChild(overlay)
    this._overlayAdded = true

    if (clickHandler) {
      overlay.addEventListener('click', clickHandler)
    }
  }

  closeOverlay() {
    const overlay = document.querySelector('.nova-overlay')

    if (!overlay) return

    this._overlayAdded = false
    overlay.remove()
  }

  bodyOverlay(clickHandler = null) {
    if (this._overlayAdded) {
      this.closeOverlay()
      return
    }

    this.createOverlay(clickHandler)
  }
}
